import * as types from "./actionTypes";
import infrastructuurApi from "../api/infrastructuurApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";

// ----------------------------------------------------------------------------
export function infrastructurenByDossierLoaded(infrastructuren, isSaved = true) {
	return {
		type: types.INFRASTRUCTUREN_BY_DOSSIER_LOADED,
		body: {
			items: infrastructuren,
			isSaved: isSaved
		}
	};
}

export function loadInfrastructurenByDossierId(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());
		return infrastructuurApi.getAllByDossierId(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(infrastructurenByDossierLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function unloadBovenlokaliteit() {
	return function (dispatch) {
		dispatch(bovenlokaliteitUnloaded());
	};
}

export function bovenlokaliteitUnloaded() {
	return {
		type: types.BOVEN_LOKALITEIT_UNLOADED
	};
}